export const NA = '';
export const dateTimeDisplayFormat = 'DD MMM YYYY - hh:mm A'; // https://momentjs.com/docs/#/parsing/
export const dateDisplayFormat = 'DD MMM YYYY';